<template>
    <div class="general-wrapper">
        <h1 class="header-title">COVID-19 Cardiology Coalition</h1>
          <v-divider></v-divider>
                <div class="mobile-video">
                       <video-embed src="https://www.youtube.com/embed/ADA_EmVAJgM"></video-embed>
                </div>
          <v-divider></v-divider>

        <div class="data-wrapper">
            <table v-for="item in sortedHomeContent" :key="item.id">
                    <tbody>
                        <div class="anchor" v-bind:id="item.shortcut"/>

                        <tr>
                            <td class="title">
                                {{item.name}}
                            </td>
                        </tr>
                        <tr>
                            <td class='time-stamp'>
                                Last updated: {{item.updated_at.seconds*1000|moment("MM-DD-YY")}}
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div v-html="item.data"></div>
                            </td>
                        </tr>
                      
                    </tbody>
                </table>
                
        </div>
    </div>
</template>
<script src="https://cdn.jsdelivr.net/lodash/4.13.1/lodash.js"></script>

<script>
import {mapGetters} from 'vuex'  

import {analytics} from "../firebase";
analytics.logEvent("Home");

    export default {
        name: "home",
        components: {
        },
        computed: {
            ...mapGetters([
                'getHomeContent',
            ]),
            sortedHomeContent: function () {
                return _.orderBy(this.getHomeContent, 'order')
            },
        },
        
    }
</script>

<style scoped>
 
    .mobile-video{
        display:contents;
        padding:5px;
    }

    @media screen and (min-width: 992px){
          .mobile-video {
            display: none;

      }
      }

</style>